import React from "react"

import ItemDetailsColumns from "../../../common/columns/ItemDetailsColumns"
import ItemDetailsColumn from "../../../common/columns/ItemDetailsColumn"
import FeedItemConceptDetails from "../FeedItemConceptDetails"
import EditFeedItemPublishingDetails from "./EditFeedItemPublishingDetails"
import EditFeedItemArticleDetails from "./EditFeedItemArticleDetails"
import EditFeedItemInsightDetails from "./EditFeedItemInsightDetails"
import ViewFeedItemInsightDetails from "../view/ViewFeedItemInsightDetails"
import KnowledgeFingerprintWidget from "../KnowledgeFingerprintWidget"

export default ({
    model,
    fulltext,
    isFetchingFulltext,
    onEventChange,
    onValueChange,
    onImageChange,
}) => (
    <form name="form">
        <ItemDetailsColumns className="article-item-container">
            <ItemDetailsColumn>
                <div id="source">
                    <EditFeedItemPublishingDetails
                        publisher={model.publisher}
                        title={model.title}
                        link={model.link}
                        time={model.time}
                        timeAnalyzed={model.time_analyzed}
                        image={model.image}
                        language={model.language}
                        imagePreviewURL={model.imagePreviewURL}
                        {...{ onValueChange, onEventChange, onImageChange }}
                    />
                </div>
                <div id="insights">
                    <EditFeedItemInsightDetails
                        topics={model.topics}
                        onValueChange={onValueChange}
                    />
                </div>
                {model.fp_topics && model.fp_topics.length && (
                    <div>
                        <ViewFeedItemInsightDetails
                            header="Fingerprint topics"
                            topics={model.fp_topics}
                            showScore={true}
                        />
                    </div>
                )}
            </ItemDetailsColumn>
            <ItemDetailsColumn>
                <div id="article">
                    <EditFeedItemArticleDetails
                        fulltext={fulltext}
                        isFetchingFulltext={isFetchingFulltext}
                        summary={model.summary}
                        authors={model.authors}
                        license={model.license}
                        {...{ onValueChange, onEventChange }}
                    />
                </div>
                <div id="concepts">
                    <FeedItemConceptDetails
                        concepts={model.concepts}
                        canEdit={true}
                    />
                </div>
                {model.fp && model.fp.length ? (
                    <div id="fp">
                        <KnowledgeFingerprintWidget fingerprint={model.fp} />
                    </div>
                ) : null}
            </ItemDetailsColumn>
        </ItemDetailsColumns>
    </form>
)
